import { BaseShaderMaterial } from 'ohzi-core';
import fragment from './CloudsPoint.frag'
import vertex from './CloudsPoint.vert'
import { ResourceContainer } from 'ohzi-core';

import { Vector2 } from 'three';
import { Color } from 'three';
import { sRGBEncoding } from 'three';
import { RepeatWrapping } from 'three';



export default class CloudsPointMaterial extends BaseShaderMaterial
{
  constructor()
  {

  	ResourceContainer.get_resource("clouds").wrapS = RepeatWrapping
  	ResourceContainer.get_resource("clouds").wrapT = RepeatWrapping
  	//let v2 = new Vector2(1,1);
  	//console.log(v2)
    super(vertex, fragment, {
      map: {value : ResourceContainer.get_resource("clouds")},
      uRepeat : {value:new Vector2()},
      lights: true,
      fog: true,
      transparent: true,
     }
    );
    this.uniforms.uRepeat.value.set(1/2,1/4)
    this.transparent = true;
    this.extensions.derivatives = true;
  }

  update() {

  }
    
};
